"use client";
import classNames from "classnames";
import { Link } from "react-router-dom";
import useSWR from "swr";
import { getGroups, imageUrlFor } from "../sanity/client";
import { ScribbleGroup } from "../sanity/sanity.types";
import styles from "./groups.module.css";

export default function Groups() {
  const { data: groups = [] } = useSWR<ScribbleGroup[]>("groups", getGroups);

  console.log(groups.filter((el) => el.past));

  return (
    <>
      <h1 className="font-bold text-3xl mb-4">Groups</h1>

      <div className={classNames("flexGridThirds", styles.eventsGrid)}>
        {groups
          .filter((el) => !el.past)
          .map((item) => {
            return <GroupThumb key={item._id} group={item} />;
          })}
      </div>

      <hr />

      <h1 className="font-bold text-3xl mb-4 mt-4">Past Groups</h1>

      <div className={classNames("flexGridThirds", styles.eventsGrid)}>
        {groups
          .filter((el) => el.past)
          .map((item) => {
            return <GroupThumb key={item._id} group={item} />;
          })}
      </div>
    </>
  );
}

interface GroupThumbProps {
  group: ScribbleGroup;
}

const GroupThumb: React.FC<GroupThumbProps> = ({ group }) => {
  return (
    <div
      className={classNames("col", styles.event)}
      key={group.slug + Math.random().toString()}
    >
      <Link to={"/group/" + group?.slug?.current}>
        <div className={styles.thumb}>
          <div className={styles.title}>
            <h3 className="font-bold mb-4 text-lg">{group.title}</h3>
          </div>
          {group.image && (
            <img
              alt=""
              loading="lazy"
              src={imageUrlFor(group.image.asset?._ref ?? "")
                .width(800)
                .url()}
            />
          )}
        </div>
      </Link>
    </div>
  );
};
